import { Button, Card, CardContent } from 'app-template-lib/components/shadcn';

export function KeikakuIntroCard(props: { lgcode: string; jigyoYear: string }) {
    const { lgcode, jigyoYear } = props;
    const data = {
        keikakuName: '琴浦まちづくりビジョン（第3次総合計画）',
        label: '目指す将来像',
        title: 'ひとが輝く、豊かな自然と食のまち琴浦',
        content:
            '私たちのまちは、日本海と大山に囲まれ、美しい自然と多彩な食にあふれています。<br/>この恵まれた環境こそ絆を大切にする心豊かなひとを育む土壌と養分であり、次の世代へとしっかりと繋ぎ、さらに活かしていくべきものです。<br/>ここに暮らす一人ひとりの個性や生き方が尊重され、生きがいを持って自分自身の思いを叶えることができる、そんな「輝くひと」たちが育ち、集い、根付くまちを目指します。',
    };

    const keikaku_url = 'https://www.town.kotoura.tottori.jp/docs/2022092600041/files/vision_honshi.pdf';

    const HtmlContent = ({ htmlData }: { htmlData: string }) => {
        return <div dangerouslySetInnerHTML={{ __html: htmlData }} />;
    };

    return (
        <>
            <div>
                <h1 className=" text-lg  md:text-xl  mx-4 md:mx-8 pt-5">{data.keikakuName}</h1>
            </div>
            <div className="flex w-full gap-6 mb-8  justify-center p-4">
                <Card className="flex-grow overflow-auto mx-1 mb-3  shadow-none border-none">
                    <CardContent className="container mx-auto  grid grid-cols-1 lg:grid-cols-[7fr_3fr] gap-6">
                        <section className="w-full aspect-[4/3] md:hidden  mt-3">
                            <img
                                className="rounded-md"
                                src={`${import.meta.env.VITE_AWS_URL}${lgcode}/${jigyoYear}/keikaku_main_visual.png`}
                                alt="keikaku"
                            />
                        </section>
                        {/* 左側のテキストコンテンツ */}
                        <section className="md:m-8">
                            <label className="text-sm">{data.label}</label>
                            <h2 className="text-lg">{data.title}</h2>
                            <div className="pt-4 text-sm">
                                <HtmlContent htmlData={data.content} />
                            </div>

                            <Button
                                className="mt-5 w-full color-button"
                                onClick={() => {
                                    window.open(keikaku_url, '_blank');
                                }}
                            >
                                総合計画
                            </Button>
                        </section>

                        {/* 右側の画像コンテンツ */}
                        <section className="w-full flex  flex-col hidden md:inline-flex mt-5 ">
                            <img
                                className="rounded-md shadow-xl"
                                src={`${import.meta.env.VITE_AWS_URL}${lgcode}/${jigyoYear}/keikaku_main_visual.png`}
                                alt="keikaku"
                            />
                        </section>
                    </CardContent>
                </Card>
            </div>
        </>
    );
}
